import { mapValues } from "lodash";

import { makePromiseFromObject } from "./promise";
import { fileFromJSON, fileToJSON } from "./file";

export const getDefaultState = () => ({
  files: [],
  data: {},
  step: 0
});

export async function saveFormState(form_id, { files, data, step }) {
  try {
    localStorage.setItem(
      form_id,
      JSON.stringify({
        data: data,
        files: await makePromiseFromObject(mapValues(files, fileToJSON)),
        step: step
      })
    );
  } catch (err) {
    console.error(err);
  }
}

export async function restoreFormState(form_id) {
  try {
    const item = localStorage.getItem(form_id);
    if (item) {
      const state = JSON.parse(item);
      if (
        typeof state === "object" &&
        typeof state.data === "object" &&
        typeof state.files === "object" &&
        typeof state.step === "number"
      ) {
        const { files, data, step } = state;
        const s = {
          files: mapValues(files, fileFromJSON),
          data,
          step
        };
        return { state: s, active: true };
      }
    }
  } catch (err) {
    console.error(err);
    localStorage.removeItem(form_id);
  }
  return { state: getDefaultState(), active: false };
}

export function removeFormState(form_id) {
  try {
    localStorage.removeItem(form_id);
  } catch (err) {
    console.error(err);
  }
}
